import { render } from "./SurveyDefaultLabelsForm.vue?vue&type=template&id=a72d1ab0"
import script from "./SurveyDefaultLabelsForm.vue?vue&type=script&lang=js"
export * from "./SurveyDefaultLabelsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__